import styles from './index.module.css';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { useEffect } from 'react';
import { useRef } from 'react';
import DOMPurify from 'dompurify';
import { useState } from 'react';

const Hundred = ({ textData }) => {
  const ctnRef = useRef(null);
  const videoPlay = useRef(false);
  const videoRef = useRef(null);

  useEffect(() => {
    document.querySelectorAll(`.${styles.textBox} > h1`).forEach((item) => {
      ScrollTrigger.create({
        trigger: item,
        start: 'top 80%',
        onEnter: () => {
          item.classList.add('active');
        },
      });
    });
  }, []);
  return (
    <div className={styles.ctn} ref={ctnRef}>
      <video
        data-fade-in-play={true}
        ref={videoRef}
        playsInline
        muted
        preload="true"
        src="https://bucket.zhiyun-tech.com/detail/fiveraym40/fiveraym40-video-40w.mp4"
        poster='https://bucket.zhiyun-tech.com/detail/fiveraym40/fiveraym40-video-40w-cover.jpg'
      ></video>

      <div className={styles.textBox}>
        <h1
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text7']),
          }}
        ></h1>
        <h1
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text8']),
          }}
        ></h1>

        <h1
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text9']),
          }}
        ></h1>
        <h1
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text10']),
          }}
        ></h1>
      </div>
    </div>
  );
};

export default Hundred;
